<button
  class="toggle-switch"
  (click)="toggle()"
  tabindex="0"
  [class.toggle-switch--is-activated]="isActivated"
>
  <span class="toggle-switch__track"></span>
  <span class="toggle-switch__knob"></span>
</button>
